
import { Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, string_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";

export class ImageDecorator extends Record {
    constructor(src) {
        super();
        this.src = src;
    }
}

export function ImageDecorator_$reflection() {
    return record_type("Bindings.Feliz.ReactViewer.ImageDecorator", [], ImageDecorator, () => [["src", string_type]]);
}

